import { useLocation, Navigate } from 'react-router-dom';
import routes from '../constants/routes';
import { getCookie } from './cookie-service';

export function PrivateRoute({ children, allowedRoles = [] }) {
  const auth = getCookie('veriipro-emp-user');
  const location = useLocation();

  if (!auth) {
    return <Navigate to={routes.login} state={{ from: location }} />;
  }
  if (allowedRoles.length > 0) {
    const userRole = auth?.role;
    if (!allowedRoles.includes(userRole)) {
      return <Navigate to={routes.notFound} replace />;
    }
  }

  return children;
}
